import { ActionTypes } from "../constants";

const reduceEvents = (state = [], action) => {
    switch (action.type) {
        case ActionTypes.GET_TMS_EVENT_LIST_SUCCESS:
            return action.data || [];

        case ActionTypes.GET_TMS_EVENT_SUCCESS:
            return !state ? [action.data] : [...state, action.data];

        case ActionTypes.LOGOUT:
            return null;

        default:
            return state;
    }
};


export const getEvent = (events, eventId) => !events ? [] : events.find(({id}) => id === Number(eventId));

export default reduceEvents;
